const CAFE24_CODE = {
  available_payment_methods: {
    A: '계좌이체',
    B: '편의점',
    C: '신용카드',
    D: '토스',
    E: '가상계좌',
    H: '휴대폰',
    I: '쿠폰 적용 상품의 주문 금액',
    K: '케이페이',
    M: '적립금',
    N: '페이코',
    O: '카카오페이',
    P: '페이나우',
    R: '무통장입금',
    S: '스마일페이',
    V: '네이버페이',
    ALL: '제한없음'
  },
  available_price_type: {
    O: '주문 금액 기준',
    P: '상품 금액 기준',
    U: '제한 없음'
  },
  available_price_type_detail: {
    I: '쿠폰 적용 상품의 주문 금액',
    U: '모든 상품의 주문 금액'
  },
  benefit_type: {
    A: '할인금액',
    B: '할인율',
    C: '적립금액',
    D: '적립율',
    E: '기본배송비 할인(전액할인)',
    F: '즉시적립',
    G: '예치금',
    H: '기본배송비 할인(할인금액)',
    I: '기본배송비 할인(할인율)'
  },
  canceled: {
    F: '미취소',
    M: '부분 취소',
    T: '취소'
  },
  case: {
    1: ' SMS 수신동의 + 이메일 수신동의 적립금',
    2: ' SMS 수신동의 적립금',
    3: ' 회원 정보 수정 이벤트',
    4: ' 오프라인취소-구매시 지급한 적립금 회수',
    5: ' 오프라인구매-적립금 지급',
    6: ' [품목추가] 관리자 직접 지급 [상품] 적립금',
    7: ' [품목추가] 관리자 직접 지급 [회원] 적립금',
    8: ' [품목교환] 관리자 직접 지급 [상품] 적립금',
    9: ' [품목교환] 관리자 직접 지급 [회원] 적립금',
    A: '관리자 직접 적립금 부여',
    AA: '바로가기(링콘) 접속 후 구매에 따른 추가 적립금 차감',
    AB: '적립금 소멸',
    AD: '회원정보 이벤트 참여 적립금',
    AE: '플러스앱 주문 적립금',
    AF: '주문취소에 의한 플러스앱주문 적립금 차감',
    AG: '오프라인구매-적립금 사용',
    AH: '오프라인취소-구매시 사용한 적립금 복원',
    AI: '이벤트팩토리 적립금',
    AK: '플러스앱 푸시알림 ON 적립금',
    AL: '플러스앱 설치 적립금',
    AM: 'API 를 통한 적립금',
    AN: '플러스앱 푸시 혜택받기로 인한 적립금',
    AO: '구매 확정 취소에 의한 플러스앱 적립금 차감',
    AP: '구매 확정 취소에 의한 쿠폰 적립금 차감',
    AQ: '구매 확정 취소에 의한 회원등급 적립금 차감',
    AR: '구매 확정 취소에 의한 상품 적립금 차감',
    AS: '구매 확정 취소에 의한 링콘 적립금 차감',
    B: '주문취소로 인한 환불시 환불금을 적립금으로 부여',
    C: '적립대기중이던 적립금 취소',
    D: '반품완료 후 사용가능',
    E: 'csv파일로 등록된 회원',
    F: '주문취소로 인해 상품에 대한 적립금 차감',
    G: '추천한 신규 가입자에게 적립금 부여',
    H: '(기존 적립금 내역용 레거시 타입) 주문시 회원등급에 따른 적립금 부여(회원 등급 적립금)',
    I: '주문취소로 인해 회원등급에 대한 적립금 환불',
    J: '주문취소로 인해 쿠폰에 대한 적립금 환불',
    K: '주문시 회원등급에 따른 적립금 부여(회원 등급 적립금)',
    L: '주문시 사용한 쿠폰에 따른 적립금 부여(쿠폰 적립금)',
    M: '상품구매시 사용한 적립금',
    N: '신규가입시 적립금 부여',
    O: '적립금 즉시지급 쿠폰(온라인/시리얼)',
    P: '주문시 구매한 상품에 대한 적립금 부여(구매에 대한 적립금)',
    Q: '즐겨찾기 적립금',
    R: '추천받은 기존 가입자에게 적립금 부여',
    S: '주문취소시 구매에 사용한 적립금 부여(적립금 복원(주문취소))',
    T: '뉴스레터 동의 적립금',
    U: '바로가기(링콘) 설치 후 로그인',
    V: '피추천인 주문취소에 따른 감사적립금 차감',
    W: '피추천인 주문에 따른 감사적립금 부여',
    X: '바로가기(링콘) 접속 후 구매에 따른 추가 적립금 부여',
    Y: '(기존 적립금 내역용 레거시 타입) 주문시 구매한 상품에 대한 적립금 부여(구매에 대한 적립금)',
    Z: '바로가기 아이콘 설치'
  },
  claim_reason_type: {
    A: '고객변심',
    B: '배송지연',
    C: '배송불가지역',
    D: '포장불량',
    E: '상품 불만족',
    F: '상품정보상이',
    G: '서비스불만족',
    H: '품절',
    I: '기타',
    J: '배송오류',
    K: '상품불량',
    L: '수출/통관 불가'
  },
  discount_method: {
    COUPON: '쿠폰',
    CREDIT: '예치금',
    DISCOUNT_CODE: '할인코드',
    MARKET_DISCOUNT: '마켓할인',
    POINT: '적립금'
  },
  expose_order_detail: {
    F: '노출안함',
    T: '노출함'
  },
  first_order: {
    F: '최초 주문 아님',
    T: '최초 주문'
  },
  first_payment_methods: {
    CARD: '신용카드',
    CASH: '무통장',
    CELL: '휴대폰',
    COD: '후불',
    CREDIT: '예치금',
    CVS: '편의점',
    ETC: '기타',
    GIFTCARD: '제휴상품권',
    ICASH: '가상계좌',
    POINT: '적립금',
    POINTCARD: '제휴포인트',
    POINTFY: '통합포인트',
    PREPAID: '선불금',
    TCASH: '계좌이체'
  },
  gender: {
    F: '여자',
    M: '남자'
  },
  include_tax: {
    F: '세금제외',
    T: '세금포함'
  },
  member_authentication: {
    B: '특별관리회원',
    F: '미인증',
    J: '14세미만회원',
    T: '승인'
  },
  member_type: {
    2: '회원',
    3: '비회원'
  },
  multiple_addresses: {
    F: '멀티 배송지 주문 아님',
    T: '멀티 배송지 주문'
  },
  naverpay_payment_information: {
    N: '네이버결제',
    P: 'PG결제'
  },
  news_mail: {
    F: '수신안함',
    T: '수신'
  },
  order_from_mobile: {
    F: '모바일 주문 아님',
    T: '모바일 주문'
  },
  order_status: {
    C00: '취소신청',
    C10: '취소접수 - 관리자',
    C11: '취소접수거부 - 관리자',
    C34: '취소처리중 - 환불전',
    C35: '취소처리중 - 환불완료',
    C36: '취소처리중 - 환불보류',
    C40: '취소완료',
    C41: '취소 완료 - 환불전',
    C42: '취소 완료 - 환불요청중',
    C43: '취소 완료 - 환불보류',
    C47: '입금전취소 - 구매자',
    C48: '입금전취소 - 자동취소',
    C49: '입금전취소 - 관리자',
    E00: '교환신청',
    E10: '교환접수',
    E11: '교환접수거부',
    E12: '교환보류',
    E13: '교환접수 - 수거완료(자동)',
    E20: '교환준비',
    E30: '교환처리중 - 수거전',
    E31: '교환처리중 - 수거완료',
    E32: '교환처리중 - 입금전',
    E33: '교환처리중 - 입금완료',
    E34: '교환처리중 - 환불전',
    E35: '교환처리중 - 환불완료',
    E36: '교환처리중 - 환불보류',
    E40: '교환완료',
    N00: '입금전',
    N01: '교환접수 - 교환상품',
    N02: '입금전 - 카드결제대기',
    N03: '교환접수 - 카드결제대기',
    N10: '상품준비중',
    N20: '배송준비중',
    N21: '배송대기',
    N22: '배송보류',
    N30: '배송중',
    N40: '배송완료',
    N50: '구매확정',
    R00: '반품신청',
    R10: '반품접수',
    R11: '반품 접수 거부',
    R12: '반품보류',
    R13: '반품접수 - 수거완료(자동)',
    R20: '반품 수거 완료',
    R30: '반품처리중 - 수거전',
    R31: '반품처리중 - 수거완료',
    R34: '반품처리중 - 환불전',
    R36: '반품처리중 - 환불보류',
    R40: '반품완료 - 환불완료',
    R41: '반품완료 - 환불전',
    R42: '반품완료 - 환불요청중',
    R43: '반품완료 - 환불보류'
  },
  paid: {
    F: '미결제',
    M: '부분 결제',
    T: '결제'
  },
  payment_confirmation: {
    F: '입금미확인',
    T: '입금확인'
  },
  payment_method: {
    CARD: '신용카드',
    CASH: '무통장',
    CELL: '휴대폰',
    COD: '후불',
    COUPON: '쿠폰',
    CREDIT: '예치금',
    CVS: '편의점',
    ETC: '기타',
    GIFTCARD: '제휴상품권',
    ICASH: '가상계좌',
    MARKET_DISCOUNT: '마켓할인',
    POINT: '적립금',
    POINTCARD: '제휴포인트',
    POINTFY: '통합포인트',
    PREPAID: '선불금',
    TCASH: '계좌이체'
  },
  payment_status: {
    A: '입금완료(자동)',
    F: '입금전',
    M: '추가입금대기',
    P: '결제완료',
    T: '입금완료(수동)'
  },
  points_category: {
    AVAILABLE: '가용적립금',
    UNAVAILABLE: '미가용 적립금',
    UNAVAILABLE_COUPON: '미가용회원/쿠폰적립금'
  },
  postpay: {
    F: '후불결제 아님',
    T: '후불결제'
  },
  process_status: {
    HOLD: '배송보류',
    PREPARE: '배송준비중',
    PREPAREPRODUCT: '상품준비중',
    UNHOLD: '배송보류해제'
  },
  refund_status: {
    F: '환불전',
    M: '환불보류',
    T: '환불완료'
  },
  request_pickup: {
    F: '직접발송',
    T: '수거신청'
  },
  shipping_status: {
    F: '배송전',
    M: '배송중',
    T: '배송완료',
    W: '배송보류',
    X: '발주전'
  },
  shipping_type: {
    A: '국내',
    B: '해외'
  },
  show_shipping_address: {
    F: '배송지 정보 가림',
    T: '배송지 정보 표기'
  },
  sms: {
    F: '수신안함',
    T: '수신'
  },
  solar_calendar: {
    F: '음력',
    T: '양력'
  },
  store_pickup: {
    F: '매장수령 아님',
    T: '매장수령'
  },
  undone: {
    F: '철회안함',
    T: '철회함'
  },
  use_escrow: {
    F: '에스크로 미사용',
    T: '에스크로 사용'
  },
  use_mobile_app: {
    F: '사용안함',
    T: '사용'
  },
  bacn_code: {
    BANK_2: '산업은행',
    BANK_3: '기업은행',
    BANK_4: '국민은행',
    BANK_5: '하나(외환)은행',
    BANK_7: '수협중앙회',
    BANK_11: '농협중앙회',
    BANK_12: '농협개인',
    BANK_13: '농협',
    BANK_20: '우리은행',
    BANK_209: '유안타증권',
    BANK_21: '조흥은행',
    BANK_218: 'KB증권',
    BANK_23: 'SC제일은행',
    BANK_230: '미래에셋증권',
    BANK_238: '대우증권',
    BANK_240: '삼성증권',
    BANK_243: '한국투자증권',
    BANK_247: '우리투자증권',
    BANK_26: '신한은행',
    BANK_261: '교보증권',
    BANK_262: '하이투자증권',
    BANK_263: '현대차증권',
    BANK_266: 'SK증권',
    BANK_267: '대신증권',
    BANK_269: '한화증권',
    BANK_27: '한미은행',
    BANK_270: '하나대투증권',
    BANK_278: '신한금융투자',
    BANK_279: '동부증권',
    BANK_280: '유진투자증권',
    BANK_287: '메리츠증권',
    BANK_288: '카카오페이증권',
    BANK_289: 'NH투자증권',
    BANK_291: '신영증권',
    BANK_292: '케이뱅크',
    BANK_293: '카카오뱅크',
    BANK_294: 'LIG증권',
    BANK_295: 'OK저축은행',
    BANK_296: '토스뱅크',
    BANK_297: '토스증권',
    BANK_31: 'iM뱅크',
    BANK_32: '부산은행',
    BANK_34: '광주은행',
    BANK_35: '제주은행',
    BANK_37: '전북은행',
    BANK_39: '경남은행',
    BANK_52: '모건스탠리은행',
    BANK_53: '씨티은행',
    BANK_57: '유에프제이은행',
    BANK_58: '미즈호코퍼레이트은행',
    BANK_59: '미쓰비시도쿄은행',
    BANK_60: '뱅크오브아메리카',
    BANK_71: '우체국',
    BANK_76: '신용보증기금',
    BANK_77: '기술신용보증기금',
    BANK_81: '하나은행',
    BANK_82: '농협회원조합',
    BANK_83: '도이치은행',
    BANK_84: '상호저축은행',
    BANK_85: '새마을금고',
    BANK_86: '수출입은행',
    BANK_87: '신용협동조합',
    BANK_89: '홍콩상하이은행(HSBC)',
    BANK_90: '에이비엔암로은행',
    BANK_91: '산림조합',
    BANK_93: '한국주택금융공사',
    BANK_94: '서울보증보험',
    BANK_95: '경찰청',
    BANK_99: '금융결제원',
    BANK_999: '기타'
  }
};

const AI_CAFE24_SOCKETCODE = {
  ORDER_000: {
    CATEGORY: 'ORDER',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '주문/결제 확인',
    DESCRIPTION: '주문/결제 확인 Intent Code'
  },
  ORDER_001: {
    CATEGORY: 'ORDER',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '주문 취소 요청',
    DESCRIPTION:
      '해당 주문은 조회만 가능하며, 취소 처리는 사이트 또는 상담사를 통해 진행해주셔야 합니다. 정확한 상담을 위해 주문 목록에서 문의하실 상품을 먼저 선택해 주세요.'
  },
  ORDER_002: {
    CATEGORY: 'ORDER',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      }
    },
    TITLE: '결제 확인 요청(주문 목록 확인)',
    DESCRIPTION: '고객님의 최근 주문 내역을 확인했어요. 확인하실 주문을 선택해주세요.'
  },
  ORDER_003: {
    CATEGORY: 'ORDER',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '결제 오류 요청',
    DESCRIPTION:
      '결제 상태가 확인되지 않는 경우, 정확한 확인을 위해 사이트 내 주문내역 확인 또는 상담사 연결이 필요합니다. 우선 관련 주문을 확인해볼게요.'
  },
  ORDER_004: {
    CATEGORY: 'ORDER',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '주문 변경 요청',
    DESCRIPTION:
      '해당 주문 조회는 가능하지만, 주문 변경은 사이트 또는 상담사를 통해 진행해주셔야 합니다. 정확한 상담을 위해 주문 목록에서 문의하실 상품을 먼저 선택해 주세요.'
  },
  SHIP_000: {
    CATEGORY: 'SHIP',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '배송 확인',
    DESCRIPTION: '배송 확인 Intent Code'
  },
  SHIP_001: {
    CATEGORY: 'SHIP',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      }
    },
    TITLE: '배송 조회/ 배송 상태 확인',
    DESCRIPTION: '고객님의 최근 주문 내역을 확인했어요. 배송 상태를 확인하실 주문을 선택해주세요.'
  },
  SHIP_002: {
    CATEGORY: 'SHIP',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '배송 지연 문의',
    DESCRIPTION: '배송 지연으로 불편을 드려 죄송합니다.주문을 선택해 확인하시거나, 상담사 연결을 통해 자세한 안내를 받아보실 수 있습니다.'
  },
  SHIP_003: {
    CATEGORY: 'SHIP',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '배송지 주소 변경',
    DESCRIPTION:
      '배송지 주소 변경은 사이트 또는 상담사를 통해 진행해주셔야 합니다. 정확한 상담을 위해 주문 목록에서 문의하실 상품을 먼저 선택해 주세요.'
  },
  SHIP_004: {
    CATEGORY: 'SHIP',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '묶음 배송/ 부분 배송 문의',
    DESCRIPTION:
      '일부 상품이 먼저 도착했거나 분리 배송될 수 있어요.주문 내역을 확인해드릴게요. 정확한 상담을 위해 주문 목록에서 문의하실 상품을 먼저 선택해 주세요.'
  },
  RETURN_000: {
    CATEGORY: 'RETURN',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '교환/반품/환불 요청',
    DESCRIPTION: '교환/반품/환불 확인 Intent Code'
  },
  RETURN_001: {
    CATEGORY: 'RETURN',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '교환 요청',
    DESCRIPTION:
      '교환 요청의 경우 제품 상태나 배송 상황에 따라 정확한 확인이 필요해 사이트 또는 상담사를 통해 진행해주셔야 합니다. 정확한 상담을 위해 주문 목록에서 문의하실 상품을 먼저 선택해 주세요.'
  },
  RETURN_002: {
    CATEGORY: 'RETURN',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '반품 요청',
    DESCRIPTION:
      '상품이 마음에 안 드셨거나 문제가 있었나요? 정확한 확인이 필요한 사항으로 사이트 또는 상담사를 통해 진행해주셔야 합니다. 정확한 상담을 위해 주문 목록에서 문의하실 상품을 먼저 선택해 주세요.'
  },
  RETURN_003: {
    CATEGORY: 'RETURN',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '환불 요청',
    DESCRIPTION:
      '요청하신 환불 처리를 위해 주문 내역을 불러왔어요. 정확한 확인이 필요한 사항으로 사이트 또는 상담사를 통해 진행해주셔야 합니다. 정확한 상담을 위해 주문 목록에서 문의하실 상품을 먼저 선택해 주세요.'
  },
  RETURN_000_FALLBACK: {
    CATEGORY: 'RETURN',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: 'RETURN 코드에서 불명확하거나 혼합된 요청',
    DESCRIPTION: '요청하신 내용을 정확히 도와드리기 위해 확인이 필요해요. 아래 중 어떤 처리를 원하시나요?'
  },
  MEMBER_000: {
    CATEGORY: 'MEMBER',
    BUTTON: {
      BUTTON1: {
        BUTTON_ID: 1,
        BUTTON_NAME: '주문 목록보기'
      },
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '회원 상태 확인',
    DESCRIPTION: '회원 상태 확인 Intent Code'
  },
  MEMBER_001: {
    CATEGORY: 'MEMBER',
    BUTTON: {
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '회원 상태 확인',
    DESCRIPTION: '회원님의 회원 정보는 사이트 또는 상담사를 통해 진행해주셔야 합니다. 양해 부탁드립니다.'
  },
  MEMBER_002: {
    CATEGORY: 'MEMBER',
    BUTTON: {
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '보유 쿠폰 확인, 사용 가능 여부 문의',
    DESCRIPTION: '회원님의 회원 정보는 사이트 또는 상담사를 통해 진행해주셔야 합니다. 양해 부탁드립니다.'
  },
  MEMBER_003: {
    CATEGORY: 'MEMBER',
    BUTTON: {
      BUTTON2: {
        BUTTON_ID: 2,
        BUTTON_NAME: '전문 상담사 연결'
      }
    },
    TITLE: '보유 적립금, 사용 조건 안내 문의',
    DESCRIPTION: '회원님의 회원 정보는 사이트 또는 상담사를 통해 진행해주셔야 합니다. 양해 부탁드립니다.'
  },
  PRODUCT_000: {
    CATEGORY: 'PRODUCT_000',
    BUTTON: {},
    TITLE: '상품 문의',
    DESCRIPTION: '문의하신 내용은 보다 정확한 안내를 위해 전문 상담사에게 연결해드릴게요.'
  },
  IMG_000: {
    CATEGORY: 'IMG_000',
    BUTTON: {},
    TITLE: '이미지 & 동영상 첨부',
    DESCRIPTION: '문의하신 내용은 보다 정확한 안내를 위해 전문 상담사에게 연결해드릴게요.'
  },
  FALLBACK_000: {
    CATEGORY: 'FALLBACK_000',
    BUTTON: {},
    TITLE: '카테고리 인지가 불가한 모든 문의',
    DESCRIPTION: '기본적으로 챗지피티가 인지한 후 자연스러운 대화 노출'
  },
  EMPTY: {
    CATEGORY: 'EMPTY',
    BUTTON: {},
    TITLE: '학습데이터가 1개도 없는 경우',
    DESCRIPTION: '문의하신 내용은 AI가 바로 안내드리기 어려운 내용입니다. 보다 정확한 상담을 위해 전문 상담사에게 연결해드릴게요.'
  },
  LOGIN_REQUIRED: {
    CATEGORY: 'LOGIN_REQUIRED',
    BUTTON: {},
    TITLE: '로그인을 안하고 개인 정보 관련된 질문을 하는 경우',
    DESCRIPTION: '보다 정확한 안내를 위해 쇼핑몰 로그인이 필요합니다. 로그인 후 다시 문의해 주세요.'
  }
};

const getCafe24CodeStatus = (key, val) => {
  if (val === undefined || val === null) return '-';

  let codeString = '';
  let value = '';
  if (typeof val === 'string') {
    value = val.toUpperCase();
  } else {
    value = val.toString().toUpperCase();
  }

  if (CAFE24_CODE[key] && CAFE24_CODE[key][value]) {
    codeString = CAFE24_CODE[key][value];
  } else {
    codeString = '-';
  }
  return codeString;
};

const getCafe24AIIntent = (code) => {
  if (AI_CAFE24_SOCKETCODE.hasOwnProperty(code)) {
    const codeData = AI_CAFE24_SOCKETCODE[code];
    return {
      exists: true,
      category: codeData.CATEGORY,
      title: codeData.TITLE,
      orderButton: !!(codeData.BUTTON && codeData.BUTTON.BUTTON1),
      connectButton: !!(codeData.BUTTON && codeData.BUTTON.BUTTON2)
    };
  } else {
    return {
      exists: false
    };
  }
};

export { getCafe24CodeStatus, CAFE24_CODE, AI_CAFE24_SOCKETCODE, getCafe24AIIntent };
